import moment from 'moment';

/**
 * Access to state values
 */
const getSlidesInterval = state => {
  return state.slidesIntervalInSeconds;
};

const getWallboardFontSize = state => {
  return state.fontSize;
};

const getWallboardCards = state => {
  return state.cards;
};

const getWallboardTheme = state => {
  return state.theme;
};

const getWallboardStatistics = state => {
  return state.allWallboardStatistics;
};

const getWallboardName = state => {
  return state.name;
};

/**
 * Returns a Filtered List of Stats by BPs.
 */

const getBpsByIds = state => bpIds => {
  return state.allWallboardStatistics.filter(bp => {
    if (bpIds.includes(bp.businessProcessId)) {
      return bp;
    }
  });
};

const getStatisticsByBpids = state => bpIds => {
  const possibleMediaTypes = ['Telephony', 'Fax', 'E-mail', 'Chat', 'SMS'];

  const initialDimensionsValues = possibleMediaTypes.map(mediaType => ({ name: mediaType, value: 0 }));

  const initialMediaTypeValues = { dimensionsValues: initialDimensionsValues, value: 0 };

  const possibleStats = {
    availableAgents: 'value',
    backofficeAgents: 'value',
    busyAgents: 'value',
    handleOutgoingAgents: 'value',
    onBreakAgents: 'value',
    noAnswerAgents: 'value',
    abandonedInteractions: 'object',
    answeredInteractions: 'object',
    overflowedInteractions: 'object',
    totalQueuedInteractions: 'object',
    waitingInteractions: 'object',
    averageSpeedOfAnswer: 'time',
    serviceLevel: 'value',
    averageRingTime: 'value',
    longestWaitingTime: 'time',
    callbacksFailedPercent: 'value',
    callbacksProcessed: 'value',
    callbacksPurged: 'value',
    callbacksReachedPercent: 'value',
    callbacksRequested: 'value',
    callbacksToBeProcessed: 'value'
  };

  const initialStats = {};
  Object.keys(possibleStats).forEach(key => {
    const initialObject = {
      alertType: 'None',
      value: possibleStats[key] === 'value' ? 0 : initialMediaTypeValues
    };
    initialStats[key] = initialObject;
  });

  // Sum all the statistics on BpIds
  // ToDo: Optimize this algorithm, return the stats needed from where it's called
  return state.allWallboardStatistics.reduce((acc, value) => {
    if (!bpIds.includes(value.businessProcessId)) return acc;

    const sumOfStats = Object.keys(possibleStats).reduce((object, key) => {
      const type = possibleStats[key];

      object[key] = {};
      if (acc[key].alertType === 'Alert' || value[key].alertType === 'Alert') {
        object[key].alertType = 'Alert';
      } else if (acc[key].alertType === 'Warning' || value[key].alertType === 'Warning') {
        object[key].alertType = 'Warning';
      } else {
        object[key].alertType = 'None';
      }

      if (type === 'value') {
        if (key === 'serviceLevel') {
          const totalQueuedInteractions = value.totalQueuedInteractions.value.value;
          object[key].value = acc[key].value + value[key].value * totalQueuedInteractions;
          object[key].totalQueuedInteractions = (acc[key].totalQueuedInteractions || 0) + totalQueuedInteractions;
        } else {
          object[key].value = acc[key].value + value[key].value;
        }
      } else if (type === 'time') {
        const differentOperation = key === 'longestWaitingTime' ? 'findLongestValue' : '';
        object[key].value = {
          dimensionsValues: mergeDimensionsValues(
            [acc[key].value.dimensionsValues, value[key].value.dimensionsValues],
            'time',
            differentOperation,
            value.businessProcessName
          ),
          value: acc[key].value.value + moment.duration(value[key].value.value).asSeconds()
        };
      } else {
        object[key].value = {
          dimensionsValues: mergeDimensionsValues([acc[key].value.dimensionsValues, value[key].value.dimensionsValues]),
          value: acc[key].value.value + value[key].value.value
        };
      }

      return object;
    }, {});

    return sumOfStats;
  }, initialStats);
};

const mergeDimensionsValues = (data, format = '', differentOperation = '', bpName = '') => {
  const result = data.reduce(
    (function(hashTable) {
      return function(acumulator, currentArray, currentArrayIndex) {
        currentArray.forEach(function(currentObject) {
          if (!hashTable[currentObject.name]) {
            hashTable[currentObject.name] = { name: currentObject.name, bpName: '' };
            acumulator.push(hashTable[currentObject.name]);
          }
          Object.keys(currentObject).forEach(function(currentKey) {
            if (currentKey !== 'name' && currentKey !== 'bpName') {
              if (format === 'time') {
                // Only do the asSeconds operation to the time string
                const currentObjectValue =
                  typeof currentObject[currentKey] === 'string'
                    ? moment.duration(currentObject[currentKey]).asSeconds()
                    : currentObject[currentKey];
                if (differentOperation === 'findLongestValue') {
                  if ((hashTable[currentObject.name][currentKey] || 0) < (currentObjectValue || 0)) {
                    if (currentArrayIndex !== 0) {
                      hashTable[currentObject.name].bpName = bpName;
                    } else {
                      hashTable[currentObject.name].bpName = currentObject.bpName;
                    }
                    hashTable[currentObject.name][currentKey] = currentObjectValue;
                  }
                } else {
                  hashTable[currentObject.name][currentKey] =
                    (hashTable[currentObject.name][currentKey] || 0) + currentObjectValue;
                }
              } else {
                hashTable[currentObject.name][currentKey] =
                  (hashTable[currentObject.name][currentKey] || 0) + currentObject[currentKey];
              }
            }
          });
        });
        return acumulator;
      };
    })(Object.create(null)),
    []
  );
  return result;
};

const getBpName = state => bpId => {
  const bp = state.allWallboardStatistics.find(element => element.businessProcessId === bpId);
  return bp ? bp.businessProcessName : '';
};

export default {
  getWallboardFontSize,
  getSlidesInterval,
  getWallboardCards,
  getWallboardTheme,
  getWallboardStatistics,
  getBpsByIds,
  getStatisticsByBpids,
  getWallboardName,
  getBpName
};
